export default __webpack_public_path__ + "c7a746967382c6b6157da90c723ec6a3.png";